<template>
  <div class="borrowerAttributeSelect">
    <BorrowerAttributeConstructor
      :questionText="questionText"
      :description="description"
      :descriptionTooltip="descriptionTooltip"
      :tooltipText="tooltipText"
      :helpText="helpText"
      :disclaimer="disclaimer"
      :useLargeQuestionText="largeQuestionText"
      :label="largeQuestionText ? label : null"
      :labelFor="question.labelId || 'ba' + identifier"
    >
      <template v-slot:input>
        <div class="ba-select-container" :class="{'disabled': disabled, 'form-floating': !largeQuestionText}">
          <select
            :id="question.labelId || 'ba' + identifier"
            :name="question.labelId || 'ba' + identifier"
            class="form-control form-select pe-6 text-truncate"
            :class="{
              'label-visible': value || showLabel,
              'no-value-select': !value,
              'is-invalid': v$ && v$.value && v$.value.$error,
              'disabled': disabled,
              'disabled-repressed': disabled && repressDisabledStyle
            }"
            :data-cy="question.alias == 'contact.last' ? 'businessType' : question.alias"
            :dreams-id="question.alias == 'contact.last' ? 'businessType' : question.alias"
            :disabled="disabled"
            :required="!question.mustAllowNull"
            v-model="value"
            @blur="onBlur(v$)"
            @change="onChange(v$.value, $event)"
            @click="setShowLabel(true)"
          >
            <!-- For this message to display the value must equal the data value onload -->
            <option :value="''" disabled selected>{{ !value ? question.placeholder || label : '' }}</option>
            <option
              v-for="(option, i) in question.options"
              :value="option.value"
              :key="i"
            >
              {{ option.label }}
            </option>
          </select>
          <label class="type-400" v-if="(value || showLabel) && !largeQuestionText" :for="question.labelId || 'ba' + identifier"><span>{{ label }}</span></label>
          <small class="invalid-feedback" v-if="v$.value && v$.value.$error">
            <fa-icon :icon="['fal', 'circle-exclamation']"></fa-icon> {{ errorText }}
          </small>
        </div>
      </template>
    </BorrowerAttributeConstructor>
  </div>
</template>

<script>
  import BaseBorrowerAttributeMixin from './BaseBorrowerAttributeMixin'
  import { useVuelidate } from '@vuelidate/core'
  import { requiredIf } from '@vuelidate/validators'
  export default {
    setup: () => ({ v$: useVuelidate() }),
    data () {
      return {
        selected: null,
        showLabel: null,
      }
    },
    props: {
      disabled: Boolean,
      repressDisabledStyle: Boolean,
      v: Object,
    },
    emits:['invalidity','answer'],
    created () {
      this.$watch('invalid', (invalid) => {
        this.$emit('invalidity', invalid)
      }, {immediate: true})
    },
    computed: {
      largeQuestionText() {
        return (
          this.question?.useLargeQuestionText === true
          || this.question?.useLargeQuestionText === 1
          || this.question?.useLargeQuestionText === '1'
        )
      },
      invalid() {
        return this.v$.$invalid
      },
      placeholderMessage() {
        let placeholderMsg = ''
        switch (this.question.alias) {
          case 'borrower.stateId':
            placeholderMsg = 'Select a state'
            break
          case 'businessType':
            placeholderMsg = 'Select Business Type'
            break
          default:
            placeholderMsg = 'Select an option'
        }
        return placeholderMsg
      },
      errorText() {
        let errorMsg = ''
        if (this.v$.value.$error && this.question.alias === 'borrower.stateId') {
          errorMsg = 'Please select a state'
        } else if (this.v$.value.$error && this.question.alias === 'businessType') {
          errorMsg = 'Please select a business type'
        } else if (this.v$.value.$error) {
          errorMsg = 'Please select a value'
        }
        return errorMsg
      },
    },
    mixins: [BaseBorrowerAttributeMixin],
    validations() {
      let validations
      if (this.question.alias === 'businessType') {
        validations = {
          value: {
            required: requiredIf(() => {
              return false
            }),
          }
        }
      } else {
        validations = {
          value: { required: requiredIf(() => !this.question.mustAllowNull) }
        }
      }
      return {
        ...validations,
      }
    },
    methods: {
      onChange (v$, e) {
        if (!v$.invalid) {
          v$.$touch()
        }
        this.$emit('answer', { value: e.target.value, isInvalid: v$.$error, submitImmediately: true })
      },
      onBlur (v$) {
        !this.value && this.setShowLabel(false)
        v$.$touch()
      },
      setShowLabel (payload) {
        this.showLabel = payload
      }
    }
  }
</script>

<style lang='scss' scoped>
// .ba-select-container {
//   label {
//     color: $type-300;
//   }
// }

// .marketplace-input {
//   > select {
//     text-overflow: ellipsis;
//   }
// }
</style>
